import { App, reactive } from 'vue'
import { AMapCompat, LDSMap, MouseTool, SERBIA_CENTER } from '/@/vendors/maplibre-amap-adapter'

export function useGMapManage () {
  const state = reactive({
    aMap: null as any, // AMap-kompatibilan namespace (MapLibre adapter)
    map: null as any, // instanca mape
    mouseTool: null as any,
  })

  function initMap (container: string, app: App) {
    const map = new LDSMap(container, {
      center: SERBIA_CENTER,
      zoom: 7,
    })

    state.aMap = AMapCompat
    state.map = map
    state.mouseTool = new MouseTool(map)

    // Globalno dostupno (isti ključevi kao ranije: $aMap / $map / $mouseTool)
    app.config.globalProperties.$aMap = state.aMap
    app.config.globalProperties.$map = state.map
    app.config.globalProperties.$mouseTool = state.mouseTool
  }

  function globalPropertiesConfig (app: App) {
    initMap('g-container', app)
  }

  return {
    globalPropertiesConfig,
  }
}
